<template>
  <div id="album-edit" v-loading="loading" element-loading-text="加载中...">
    <!-- <div class="page-title">{{ title }}</div> -->
    <el-card v-loading="submitting" element-loading-text="提交中...">
      <el-form
        :model="form"
        :rules="rules"
        :inline-message="true"
        ref="form"
        label-width="110px"
      >
        <section>
          <div class="section-title">
            专辑信息
            <span v-if="form.albumId">(id: {{ form.albumId }})</span>

            <span
              v-if="form.albumId"
              class="apply-icon"
              @click.stop="handleApply"
            >
              <i class="el-icon-key" />申请修改
            </span>
          </div>

          <warn-form-item label="专辑名称" prop="albumName">
            <el-input
              v-model="form.albumName"
              placeholder="请输入音乐作品官方用名"
              class="form-field"
              :disabled="!hasBasicAuth || lockBase"
              v-trans-complex="'专辑名'"
              @blur="handleTextBlur('albumName')"
            ></el-input>
          </warn-form-item>
          <el-form-item label="专辑版本" prop="srcVersion">
            <el-input v-model.trim="form.srcVersion" placeholder="" class="form-field" :disabled="!hasBasicAuth"></el-input>
          </el-form-item>
          <el-form-item label="翻译名称" prop="transName">
            <el-input
              v-model="form.transName"
              placeholder="请输入中文翻译名"
              class="form-field"
              :disabled="!hasBasicAuth"
              @blur="handleTextBlur('transName')"
            ></el-input>
          </el-form-item>
          <el-form-item label="专辑封面" prop="albumPhotoList">
            <div class="avatar">
              <div class="pic">
                <img
                  v-if="form.albumPhotoList.length"
                  :src="form.albumPhotoList[0].url"
                  class="pic-img"
                >
              </div>
              <div class="content">
                <p class="line">图片必须为jpg、jpeg、png格式</p>
                <p class="line">正方形，尺寸 > 750*750</p>
                <verify-uploader
                  class="upload-avatar"
                  action="/action/upload?type=image"
                  :show-file-list="false"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-error="hndleError"
                  :on-success="handleSuccess"
                  :before-upload="handleBeforeUpload"
                  :file-list="form.albumPhotoList"
                  :disabled="!hasBasicAuth || lockBase || uploading"
                  :accept="`.${imageType.join(',.')}`"
                >
                  <el-button size="small" type="primary" :disabled="!hasBasicAuth || lockBase || uploading">
                    {{ uploadText }}
                  </el-button>
                </verify-uploader>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="所属艺人" prop="albumSingerList">
            <search-singer
              :value.sync="form.albumSingerList"
              :default-options="singerOptions"
              :disabled="!hasBasicAuth || lockBase"
              class="form-field"
              placeholder="输入艺人名搜索"
              @change="handleSingerChange"
            >
              <template v-slot:dropdown>
                <div style="padding: 8px;">
                  找不到艺人？可以选择
                  <router-link :to="{name: 'singerList'}" target="_blank">新建艺人</router-link>
                </div>
              </template>
            </search-singer>
          </el-form-item>
          <el-form-item label="专辑类型" prop="type">
            <el-select v-model="form.type" placeholder="请选择类别" class="form-field" :disabled="!hasBasicAuth">
              <el-option
                v-for="t in typeList"
                :disabled="t.disabled"
                :key="t.id"
                :data-id="t.id"
                :label="t.name"
                :value="+t.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <warn-form-item label="地区" prop="area">
            <el-select v-model="form.area" :disabled="!hasBasicAuth" clearable class="form-field">
              <el-option
                v-for="area in areaList"
                :key="area.id"
                :data-id="area.id"
                :label="area.name"
                :value="+area.id"
              ></el-option>
            </el-select>
          </warn-form-item>
          <el-form-item label="语言" prop="language">
            <el-select
              v-model="form.language"
              filterable
              multiple
              :disabled="!hasBasicAuth"
              class="form-field"
            >
              <el-option
                v-for="(name, key) in languageMap"
                :key="key"
                :value="+key"
                :data-id="key"
                :label="name"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="一级流派" prop="genre">
            <el-select
              v-model="form.genre"
              placeholder="选择流派"
              class="form-field"
              multiple
              :disabled="!hasBasicAuth"
              @change="handleChangeGenre"
            >
              <el-option
                v-for="(name, id) in genreMap"
                :key="id"
                :label="`${id}. ${name}`"
                :value="+id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="checkShowSubGenre"
            label="二级流派"
            prop="subGenre"
          >
            <el-select
              placeholder="选择流派"
              v-model="form.subGenre"
              class="form-field"
              multiple
              filterable
              :disabled="!hasBasicAuth"
            >
              <template
                v-for="(name, id) in subGenreMap"
              >
                <el-option
                  v-if="checkSubGenre(+id)"
                  :key="id"
                  :label="`${id}. ${name}`"
                  :value="+id"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="专辑属性" prop="version">
            <el-select v-model="form.version" class="form-field" placeholder="请输入专辑属性">
              <el-option
                v-for="item in versionMap"
                :key="item.value"
                :label="item.label"
                :value="+item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="专辑UPC" prop="upc">
            <el-input v-model.trim="form.upc" class="form-field" :disabled="!hasBasicAuth">
            </el-input>
          </el-form-item>
          <el-form-item label="专辑唱片编号" prop="discNumber">
            <el-input v-model.trim="form.discNumber" class="form-field" :disabled="!hasBasicAuth">
            </el-input>
          </el-form-item>
          <el-form-item label="外显厂牌公司" prop="displayCompanyName">
            <el-input v-model.trim="form.displayCompanyName" placeholder="" class="form-field" :disabled="!hasBasicAuth || lockBase"></el-input>
          </el-form-item>
          <el-form-item label="发行时间" prop="publicTime">
            <el-date-picker
              v-model="form.publicTime"
              type="datetime"
              class="form-field"
              placeholder="专辑实际发行时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="!hasBasicAuth || lockBase"
              @change="handleDateChange($event, '发行时间')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="saleTime" style="">
            <span slot="label">
              上线时间
            </span>
            <div class="form-field" style="display: inline-block;">
              <el-date-picker
                v-model="form.saleTime"
                type="datetime"
                class="form-field"
                placeholder="专辑上线时间"
                :disabled="!hasBasicAuth"
                @change="handleDateChange($event, '上线时间')"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              <!-- <div class="desc">上线时间确定后无法修改，专辑尽量避免设置为24小时内的预发布</div> -->
            </div>
          </el-form-item>
          <!-- <el-form-item label="是否数专" prop="isDigital">
            <el-checkbox :true-label="1" :false-label="0" v-model="form.isDigital" :disabled="!hasBasicAuth"></el-checkbox>
          </el-form-item>
          <template v-if="form.isDigital">
            <el-form-item label="预售时间" prop="albumPayment.preSaleBegin" :rules="preSaleBeginRule">
              <el-date-picker
                v-model="form.albumPayment.preSaleBegin"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!hasBasicAuth"
                @change="handleDateChange($event, '预售时间')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="售卖开始时间" prop="albumPayment.paymentBegin" :rules="paymentBeginRule">
              <el-date-picker
                v-model="form.albumPayment.paymentBegin"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!hasBasicAuth"
                @change="handleDateChange($event, '售卖开始时间')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="售卖结束时间" prop="albumPayment.paymentEnd" :rules="paymentEndRule">
              <el-date-picker
                v-model="form.albumPayment.paymentEnd"
                type="datetime"
                default-time="23:59:59"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!hasBasicAuth"
                @change="handleDateChange($event, '售卖结束时间')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="售卖价格" prop="albumPayment.price" :rules="priceRule">
              <el-input-number
                v-model="form.albumPayment.price"
                class="small-form-field"
                :controls="false"
                :disabled="!hasBasicAuth"
              ></el-input-number>
            </el-form-item>
          </template> -->
          <el-form-item label="授权文件" prop="albumLicenseList">
            <verify-uploader
              action="/action/upload?type=license"
              :on-preview="handleLicensePreview"
              :on-remove="handleLicenseRemove"
              :on-error="hndleLicenseError"
              :on-success="handleLicenseSuccess"
              :before-upload="handleLicenseBeforeUpload"
              :file-list="form.albumLicenseList"
              :accept="'.' + licenseFileType.join(',.')"
              :disabled="!hasBasicAuth || licenseUploading"
            >
              <el-button type="primary" :disabled="!hasBasicAuth || licenseUploading">上传文件</el-button>
              <div slot="tip" class="el-upload__tip">支持上传 {{ licenseFileType.join('/') }} 文件</div>
            </verify-uploader>
          </el-form-item>
          <el-form-item label="专辑简介" prop="albumDesc">
            <el-input
              v-model.trim="form.albumDesc"
              v-trans-complex="'专辑简介'"
              type="textarea"
              placeholder="不超过2000字"
              :rows="5"
              :disabled="!hasBasicAuth || lockBase"
            ></el-input>
          </el-form-item>
        </section>
      </el-form>

      <div>
        <div class="section-title">歌曲信息</div>
        <verify-uploader
          action="/action/upload?type=track"
          multiple
          :accept="`.${trackType.join(',.')}`"
          :before-upload="handleMediaBefore"
          :on-progress="handleMediaProgress"
          :on-success="handleMediaSuccess"
          :on-error="handleMediaError"
          :show-file-list="false"
          :disabled="!hasBasicAuth || preUploading"
          :file-list="preUploadFileList"
        >
          <el-button type="primary" v-if="!hasBasicAuth" disabled>上传音频</el-button>
          <el-button type="primary" v-else @click="handleMedia" :disabled="preUploading">上传音频</el-button>
          <span slot="tip" class="el-upload__tip">只能上传.mp3/.flac/.ogg/.wav/.ape/.wma文件</span>
        </verify-uploader>
        <song-list ref="trackList" :songs.sync="albumTrackList" :album="form"></song-list>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center;margin-top: 16px;">
          <el-button type="primary" @click="handleSubmit" :loading="submitting" class="album-submit">提 交</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="预览" :visible.sync="previewShow" width="800px">
      <img :src="previewUrl" style="width: 700px;">
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { mapGetters } from 'vuex'
import { getDatetimeOrNull } from '@/utils/dateUtil'
import { trackType, WarnError, SBCcaseList } from '@/utils/constants'
import { SearchSinger, VerifyUploader } from '@/components'
import albumService from '@/api/album.js'
import Album from '@/models/Album.js'
import Song from '@/models/Song'
import SongList from './components/SongList'
import { validateFileExt } from '@/utils/validate'
import { ls } from '@/utils/index'
import { isAudioCheckError } from '@/utils/fileUtil'
import { fileFieldConfigList, copyrightToFE, checkModify as checkTrackModify, applyModify as applyTrackModify, checkModifySensitive as checkTrackSensitive, toListFields } from '@/views/track/const'
import {
  areaMap,
  typeMap,
  languageMap,
  typeList,
  areaList,
  licenseFileType,
  imageType,
  genreMap,
  subGenreMap,
  hasSubGenreSet,
  versionMap,
  checkAlbumModify,
  getDiffObj,
  diffArray
} from './mixin.js'

dayjs.extend(customParseFormat)

export default {
  name: 'AlbumEdit',
  components: {
    SearchSinger,
    VerifyUploader,
    SongList,
  },
  data() {
    // http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272858599991
    const nameValidator = (rule, value, callback) => {
      if (/\d{4,}/g.test(value)) {
        callback(new WarnError('专辑名不得包含发行信息'))
      } else if (SBCcaseList.some(sbc => value.includes(sbc))) {
        callback(new WarnError('请使用英文半角符号'))
      } else {
        callback()
      }
    }
    const areaValidtor = (rule, value, callback) => {
      const { form } = this
      // http://tapd.oa.com/tme_music_lib/prong/stories/view/1020369272858599991
      if (!form.albumSingerList[0] || form.albumSingerList[0].area !== form.area) {
        callback(new WarnError('请核实专辑地区是否正确'))
      } else {
        callback()
      }
    }

    const validFileList = (rule, value, callback) => {
      // 新建时跳过校验
      if (!this.isEdit) {
        return callback()
      }

      // 核心信息修改
      const isChanged = !!getDiffObj(this.form.oldLockObj, this.form, ['albumName']) || !!diffArray(this.form.oldLockObj.albumSingerList, this.form.albumSingerList)
      if (!this.lockBase && isChanged && !this.reUploadFile) {
        return callback(new Error('必须重新上传授权文件'))
      }

      callback()
    }

    return {
      form: new Album(),
      typeMap,
      areaMap,
      languageMap,
      typeList,
      areaList,
      genreMap,
      subGenreMap,
      versionMap,
      albumTrackList: [],
      previewShow: false,
      previewUrl: '',
      loading: false,
      uploading: false,
      licenseUploading: false,
      preUploading: false,
      searchSingerLoading: false,
      submitting: false,
      preUploadNum: 0,
      preUploadCompleteNum: 0,
      rules: {
        albumName: [
          { required: true, message: '请输入专辑名称', trigger: 'blur', whitespace: true },
          { validator: nameValidator, warnType: 'notify', trigger: 'blur' },
        ],
        albumDesc: [
          // { required: true, message: '请输入专辑简介', trigger: 'blur', whitespace: true },
          { max: 2000, message: '简介不能超过2000字', trigger: 'blur' }
        ],
        albumSingerList: [
          { type: 'array', required: true, message: '请关联艺人', trigger: 'change' }
        ],
        type: [
          { type: 'number', required: true, message: '请选择专辑类型', trigger: 'change' }
        ],
        area: [
          { type: 'number', required: true, message: '请选择专辑地区', trigger: 'change' },
          { validator: areaValidtor, warnType: 'notify', trigger: 'change' }
        ],
        language: [
          { type: 'array', required: true, message: '请选择专辑语言', trigger: 'change' }
        ],
        genre: [
          { required: true, message: '请填写一级流派', trigger: 'change' }
        ],
        subGenre: [
          { required: true, message: '请填写二级流派', trigger: 'change' }
        ],
        publicTime: [
          { required: true, message: '请选择发行时间', trigger: 'blur' }
        ],
        saleTime: [
          { required: true, message: '请选择上线时间', trigger: 'blur' }
        ],
        albumPhotoList: [
          { type: 'array', required: true, message: '请上传至少一张专辑图片', trigger: 'change' }
        ],
        albumLicenseList: [
          { type: 'array', required: true, message: '请上传授权文件', trigger: 'change' },
          { validator: validFileList, trigger: 'change' }
        ],
      },
      preSaleBeginRule: [
        { required: true, message: '请选择预售时间', trigger: 'change' }
      ],
      paymentBeginRule: [
        { required: true, message: '请选择售卖开始时间', trigger: 'change' }
      ],
      paymentEndRule: [
        { required: true, message: '请选择售卖结束时间', trigger: 'change' }
      ],
      priceRule: [
        { type: 'number', required: true, message: '请输入售卖价格', trigger: 'blur' }
      ],
      singerOptions: [],
      // preUploadData: [],
      preUploadFileList: [],
      uploadDataMap: {},
      uploadMapping: {},
      applyToOldTrack: false,
      lockBase: false,
      reUploadFile: false
    }
  },
  computed: {
    /**
     * @returns {Boolean}
     */
    isEdit() {
      return !!this.form.albumId
    },
    /**
     * @returns {String}
     */
    title() {
      return this.$route.query.id ? '专辑编辑' : '专辑录入'
    },
    /**
     * @returns {Object}
     */
    licenseFileType() {
      return licenseFileType
    },
    /**
     * @returns {Object}
     */
    imageType() {
      return imageType
    },
    /**
     * @returns {Object}
     */
    trackType() {
      return trackType
    },
    /**
     * @returns {Boolean}
     */
    hasBasicAuth() {
      if (!this.isEdit) {
        return true
      }

      // 如果账号绑定的厂牌 id 等于 专辑的版权公司 id，则可以修改
      return this.form.copyrightCompanyId === this.userCompany.cpCompanyId
    },
    /**
     * @returns {String}
     */
    uploadText() {
      return this.form.albumPhotoList.length ? '修改图片' : '上传图片'
    },
    ...mapGetters([
      'company',
      // 'originCompanyList',
      'copyrightCompanyList'
    ]),
    /**
     * @returns {Object}
     */
    userCompany() {
      return this.copyrightCompanyList[0] || {}
    },
    /**
     * @returns {Boolean}
     */
    checkShowSubGenre() {
      return this.form.genre.some(value => hasSubGenreSet.has(value))
    },
  },

  created() {
    const { id } = this.$route.query
    if (id) {
      this.fetchAlbum(id)
      return
    }

    // 检查是否存在未提交的草稿
    const albumDraft = ls.getItem('albumDraft')
    if (albumDraft) {
      this.$confirm('存在草稿数据，是否导入', '提示', {
        confirmButtonText: '导入',
        cancelButtonText: '不导入',
      }).then(_ => {
        this.form = albumDraft
        this.singerOptions = this.form.albumSingerList
        this.albumTrackList = albumDraft.albumTrackList
      }).catch(_ => {
        ls.setItem('albumDraft', '')
      })
    } else {
      this.form.albumCopyright.cpCompany = {
        companyId: this.userCompany.cpCompanyId,
        companyName: this.userCompany.cpCompanyName,
      }
    }
  },
  methods: {
    /**
     * 获取专辑信息
     * @param {String} id - 专辑 id
     */
    fetchAlbum(id) {
      this.loading = true
      albumService.findById({
        albumId: +id
      }).then(resp => {
        this.__reponse_time__ = resp.__reponse_time__
        // resp.albumPhotoList = resp.albumPhotoList // .filter(photo => photo.using === 1)
        this.form = new Album(resp)
        this.singerOptions = this.form.albumSingerList // 把列表赋给下拉框可选项才能显示值

        // 保存旧的专辑信息
        this.form.oldLockObj = Object.freeze(cloneDeep({
          albumName: this.form.albumName,
          displayCompanyName: this.form.displayCompanyName,
          publicTime: this.form.publicTime,
          albumDesc: this.form.albumDesc,
          albumPhotoList: this.form.albumPhotoList,
          albumSingerList: this.form.albumSingerList
        }))

        for (const track of resp.trackList) {
          const trackObj = new Song({
            ...track,
            singerList: track.trackSingerList,
            payment: track.trackPayment || { /* paymentUpdate: 0 */ },
          })

          trackObj.lockCopyright = true
          trackObj.lockMusic = true
          trackObj.lockWord = true
          trackObj.lockBasic = true

          trackObj.mediaFinish = true
          trackObj.uploadPercent = 0
          trackObj.buTrace = track.buTrace || {}
          trackObj.tempId = track.trackId
          if (trackObj.media) {
            trackObj.md5 = trackObj.media.md5
            this.uploadDataMap[trackObj.md5] = trackObj
          }
          const trackCopyright = trackObj.trackCopyright
          trackObj.trackCopyright = this.toFrontend(trackCopyright)

          const wordList = []
          for (const tc of trackObj.trackWordCopyrightList) {
            wordList.push(this.toFrontend(tc))
          }
          trackObj.trackWordCopyrightList = wordList

          const musicList = []
          for (const tc of trackObj.trackMusicCopyrightList) {
            musicList.push(this.toFrontend(tc))
          }
          trackObj.trackMusicCopyrightList = musicList

          // 把已经处理过的数据保存一份, 最后对比时使用
          trackObj.oldLockObj = Object.freeze(cloneDeep({
            firstPublicTime: trackObj.firstPublicTime,
            trackPayment: trackObj.trackPayment,
            trackCopyright: trackObj.trackCopyright,
            trackWordCopyrightList: trackObj.trackWordCopyrightList,
            trackMusicCopyrightList: trackObj.trackMusicCopyrightList,
            // 核心基础信息
            trackName: trackObj.trackName,
            trackSingerList: trackObj.trackSingerList,
            transName: trackObj.transName,
            srcVersion: trackObj.srcVersion,
            trackExtend: {
              subTitle: trackObj.trackExtend.subTitle,
              wordAuthor: trackObj.trackExtend.wordAuthor,
              musicAuthor: trackObj.trackExtend.musicAuthor,
            },
            trackLyricistList: trackObj.trackLyricistList,
            trackComposerList: trackObj.trackComposerList,
            publicTime: trackObj.publicTime,
            media: trackObj.media,
            lyricData: trackObj.lyricData
          }))

          fileFieldConfigList.forEach(config => {
            if (!trackObj[config.key]) {
              trackObj[config.key] = []
            }
          })

          this.albumTrackList.push(trackObj)
        }
        this.albumTrackList.sort((a, b) => {
          return a.location - b.location
        })

        this.lockBase = true
      }).catch(error => {
        console.error(error)
        this.$message.error('查询异常.' + error.message)
        this.form = new Album()
      }).finally(_ => {
        this.loading = false
      })
    },

    handleChangeGenre(val) {
      this.form.subGenre = this.form.subGenre.filter(item => {
        return this.checkSubGenre(item)
      })
    },

    checkSubGenre(val) {
      return this.form.genre.includes(Math.floor(val / 100))
    },

    toFrontend(trackCopyright) {
      return copyrightToFE.call(this, trackCopyright)
    },

    handleTextBlur(key) {
      this.form[key] = this.form[key].trim()
    },

    handleDateChange(time, fieldName) {
      const timeObj = dayjs(time, 'YYYY-MM-DD HH:mm:ss')
      if (timeObj.isBefore(dayjs())) {
        this.$alert(`<b>${fieldName}</b>早于当前时间，请确定输入是否正确`, '提示', {
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
      }
    },
    handleSingerChange(selection) {
      if (selection[0]) {
        if (selection[0].area !== this.form.area) {
          this.$notify({
            title: '提示',
            message: '请核实专辑地区是否正确',
            type: 'warning'
          })
        }
      }
    },

    hndleError(err, file, fileList) {
      this.uploading = false
      this.$message.error('上传失败: ' + err.message)
    },

    handleSuccess(resp, file, fileList) {
      this.uploading = false
      const respData = resp.data
      const fileData = {
        url: this.$toPreview(respData.url),
        md5: respData.md5,
        photoPath: respData.file_id,
        photoUrl: respData.url,
        photoSize: file.size,
        photoHeight: respData.file_info.height,
        photoWidth: respData.file_info.width,
        orderIndex: 0,
      }
      this.form.albumPhotoList = [fileData]
    },

    handleRemove(file, fileList) {
      this.form.albumPhotoList = fileList
    },

    handleBeforeUpload(file) {
      if (!validateFileExt(imageType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }
      if (this.form.albumPhotoList.length === 0) {
        this.uploading = true
        return Promise.resolve()
      }

      return this.$confirm('只能上传一张专辑图片，是否覆盖旧的图片?', '提示', {
        confirmButtonText: '覆盖',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.uploading = true
        return Promise.resolve()
      }).catch(() => {
        return Promise.reject()
      })
    },

    handlePreview(file) {
      this.previewUrl = file.url
      this.previewShow = true
    },

    hndleLicenseError(err, file, fileList) {
      console.error(err)
      this.licenseUploading = false
      this.form.albumLicenseList = fileList
    },

    handleLicenseSuccess(resp, file, fileList) {
      const respData = resp.data
      const fileData = {
        url: this.$toPreview(respData.url),
        name: file.name,
        licenseUrl: respData.url,
        licensePath: respData.file_id,
        fileMd5: respData.md5,
        fileName: file.name,
      }
      this.form.albumLicenseList.push(fileData)

      this.licenseUploading = false

      // 如果是修改核心内容重新上传后，修改标志位
      if (!this.lockBase) {
        this.reUploadFile = true
      }
    },
    handleLicenseRemove(file, fileList) {
      this.form.albumLicenseList = fileList
    },
    handleLicenseBeforeUpload(file) {
      if (!validateFileExt(licenseFileType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      this.licenseUploading = true
      return Promise.resolve()
    },
    handleLicensePreview(file) {
      open(file.url, '_blank')
    },

    handleMedia(evt) {
    },

    handleMediaProgress(event, file, fileList) {
      this.uploadDataMap[this.uploadMapping[file.uid]].uploadPercent = event.percent
    },

    /**
     * @param {Object} file 和其他 file 对象属性一样,多了 md5 这个值
     */
    handleMediaBefore(file) {
      if (!validateFileExt(trackType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      if (!this.addMedia(file)) {
        this.$message({
          message: '不能上传重复歌曲',
          type: 'error'
        })
        return Promise.reject()
      }

      this.preUploadNum = this.preUploadNum + 1
      this.preUploading = true

      return Promise.resolve()
    },

    /**
     * 上传选了文件，先添加一条歌曲记录，给用户操作
     * 上传完成后再显示名字、歌手名等信息，并且把 media 信息插入 trackObj
     */
    addMedia(file) {
      const { albumTrackList, form } = this
      if (albumTrackList.find(item => item.md5 === file.md5)) return false

      const language = form.language[0]
      let name = file.name
      name = name.slice(0, name.lastIndexOf('.'))
      const trackObj = new Song({
        trackName: name,
        location: this.albumTrackList.length + 1,
        singerList: this._transformSinger(this.form.albumSingerList, true),
        language: language !== undefined ? language : 0,
        status: 0,
        fFrom: 0,
        genre: form.genre.join(','),
        saleTime: form.saleTime,
        publicTime: form.publicTime,
        trackCopyrightCompetitor: {
          copyrightTo: null
        },
        trackExtend: {
          subGenre: form.subGenre.join(',')
        },

        // 标记当前歌曲的 tab 是否有被打开过, fix: 如果没被打开导致最终 validate 没触发的问题
        // 如果没被打开过, 需要手动校验下字段是否有值
        hasOpend: false,
      })

      trackObj.trackCopyright.originCpCompany.companyName = this.company.companyName
      trackObj.trackCopyright.originCpCompany.companyId = this.company.companyId
      trackObj.create = true

      trackObj.tempId = file.uid
      trackObj.md5 = file.md5
      trackObj.uploadPercent = 0
      trackObj.mediaFinish = false

      this.uploadMapping[file.uid] = file.md5
      this.albumTrackList.push(trackObj)
      this.uploadDataMap[file.md5] = trackObj

      return true
    },

    handleMediaError(error, file, fileList) {
      console.error(error)
      this.preUploadCompleteNum++

      this.$message({
        type: 'error',
        message: `<${file.name}>上传失败，请稍后重试。`
      })

      const errorTrack = this.uploadDataMap[this.uploadMapping[file.uid]]
      errorTrack.uploadPercent = 0
      errorTrack.mediaFinish = false

      this.whetherMediaFinish()
    },

    handleMediaSuccess(resp, file, fileList) {
      this.preUploadCompleteNum++
      const respData = resp.data
      const trackData = this.uploadDataMap[respData.md5]

      trackData.mediaFinish = true // 表示音频上传完成, 无论有没严重错误
      trackData.hasError = isAudioCheckError(respData.file_info.audio_check)
      trackData.uploadPercent = 0 // 上传进度回归0
      trackData.media = {
        mediaUrl: respData.url,
        mediaPath: respData.file_id,
        using: 1,
        remarks: this.fileRemarks,
        fileType: file.name.slice(file.name.lastIndexOf('.') + 1),
        fileSize: file.size,
        fileName: file.name,
        md5: respData.md5,
        duration: respData.file_info.duration != null ? respData.file_info.duration : 0,
        checkQuality: respData.file_info.audio_check,
      }

      this.whetherMediaFinish()

      this.$transComplexText(trackData.trackName, '歌曲名', value => { trackData.trackName = value })
    },

    whetherMediaFinish() {
      if (this.preUploadCompleteNum === this.preUploadNum) {
        // 上传完了, 隐藏文件列表

        this.preUploading = false
        this.preUploadFileList = []
      }
    },

    async handleSubmit() {
      if (this.uploading) {
        return this.$message.warning('专辑图上传中')
      }
      if (this.preUploading) {
        return this.$message.warning('歌曲上传中.')
      }
      if (this.licenseUploading) {
        return this.$message.warning('授权文件上传中.')
      }

      this.$refs.form.validate(async(valid, invalidList) => {
        if (valid) {
          const form = this.form
          const { albumSingerList } = form

          const postData = {
            ...cloneDeep(form),
            trackList: [],
            newTrackList: [],
            albumId: form.albumId ? +form.albumId : void (0),
          }
          postData.srcAlbumId = postData.srcAlbumId ? postData.srcAlbumId : void (0)

          // 艺人
          postData.albumSingerList = this._transformSinger(albumSingerList)

          // 解锁了, 检查是否有字段变化
          if (this.isEdit && !this.lockBase) {
            try {
              await checkAlbumModify(postData)
            } catch (error) {
              return
            }

            // 需要审核的字段，提交时需要以 旧的值 提交
            Object.assign(postData, postData.oldLockObj)
          }
          postData.oldLockObj = undefined

          // 歌曲
          try {
            await this.$refs.trackList.validate()
          } catch (error) {
            return this.$message({
              message: error.message,
              type: 'error'
            })
          }

          const preTableData = this.$refs.trackList.getData()

          if (!this.submitCheck(postData, preTableData)) {
            return
          }

          // 经过校验的数据，保存到缓存中
          if (!postData.albumId) {
            ls.setItem('albumDraft', { ...postData, albumTrackList: preTableData })
          }

          // 开始   数据处理为后台需要的格式
          postData.srcGenre = ''
          postData.genre = postData.genre.join(',')
          postData.subGenre = postData.subGenre.join(',')
          postData.language = this.form.language.join(',')

          const albumCpCompany = postData.albumCopyright.cpCompany
          const modifiedTrackList = []
          for (let i = 0; i < preTableData.length; i++) {
            const trackObj = preTableData[i]
            trackObj.location = i + 1
            // 歌曲艺人
            trackObj.trackSingerList = this._transformSinger(trackObj.trackSingerList)
            trackObj.trackComposerList = this._transformSinger(trackObj.trackComposerList)
            trackObj.trackLyricistList = this._transformSinger(trackObj.trackLyricistList)
            trackObj.trackArrangerList = this._transformSinger(trackObj.trackArrangerList)
            trackObj.trackProducerList = this._transformSinger(trackObj.trackProducerList)
            trackObj.srcGenre = ''
            trackObj.genre = trackObj.genre.join(',')
            trackObj.trackExtend.subGenre = trackObj.trackExtend.subGenre.join(',')
            trackObj.srcVersion = trackObj.srcVersion ?? ''

            const lockKeys = ['lockCopyright', 'lockMusic', 'lockWord', 'lockBasic']
            const changeLockField = lockKeys.some(key => trackObj[key] === false)
            if (trackObj.trackId && changeLockField) {
              // 解锁了, 保存该歌曲副本，保存专辑信息后提交字段修改申请
              const modifyObj = checkTrackModify(trackObj)
              if (modifyObj) {
                modifiedTrackList.push(modifyObj)
              }

              // 需要审核的字段，提交时需要以 旧的值 提交
              const newWordIdList = trackObj.trackWordCopyrightList.map(wc => wc.id)
              const newMusicIdList = trackObj.trackMusicCopyrightList.map(mc => mc.id)
              // 扩展字段只重置审核字段
              const trackExtend = Object.assign({}, trackObj.trackExtend, trackObj.oldLockObj.trackExtend)
              Object.assign(trackObj, trackObj.oldLockObj, { trackExtend })

              // 词曲版权, 判断是否有删除,有的话直接去掉
              trackObj.trackWordCopyrightList = trackObj.trackWordCopyrightList.filter(wc => newWordIdList.includes(wc.id))
              trackObj.trackMusicCopyrightList = trackObj.trackMusicCopyrightList.filter(mc => newMusicIdList.includes(mc.id))
            }
            trackObj.oldLockObj = undefined
            trackObj.trackLicenseList = []

            // 把专辑的版权公司赋予到歌曲的录音、词曲版权上
            // 转化版权字段格式
            const cpCompany = trackObj.trackCopyright.cpCompany
            if (!cpCompany || cpCompany.companyId !== albumCpCompany.companyId) {
              trackObj.trackCopyright.cpCompany = albumCpCompany
            }
            trackObj.trackWordCopyrightList = trackObj.trackWordCopyrightList.map(right => {
              if (!right.cpCompany || right.cpCompany.companyId !== albumCpCompany.companyId) {
                right.cpCompany = albumCpCompany
              }
              return this.cpToBackend(right)
            })
            trackObj.trackMusicCopyrightList = trackObj.trackMusicCopyrightList.map(right => {
              if (!right.cpCompany || right.cpCompany.companyId !== albumCpCompany.companyId) {
                right.cpCompany = albumCpCompany
              }
              return this.cpToBackend(right)
            })

            trackObj.trackCopyrightCompetitor = trackObj.trackCopyrightCompetitor || {}
            if (!trackObj.trackCopyrightCompetitor.cpCompanyId) {
              trackObj.trackCopyrightCompetitor.cpCompanyId = trackObj.trackCopyright.cpCompany && trackObj.trackCopyright.cpCompany.companyId
            }

            this.cpToBackend(trackObj.trackCopyright)
            // end

            if (trackObj.trackId) {
              postData.trackList.push(trackObj)
            } else {
              postData.newTrackList.push(trackObj)
            }
          }

          // console.log(postData)
          await this.saveAlbum(postData)

          // FIX 现新增部分直接修改歌曲信息的逻辑（跳过字段审核，脚本直接保存）
          // 如果先检查修改字段会导致 applyTrackModify 保存的修改数据被原数据覆盖，故置后
          if (modifiedTrackList.length) {
            // 检测歌曲敏感词
            try {
              await Promise.all(modifiedTrackList.map(modifyObj => checkTrackSensitive(modifyObj)))
            } catch (error) {
              return
            }

            modifiedTrackList.forEach(modifyObj => applyTrackModify(modifyObj))
          }
        } else {
          const invalid = invalidList[Object.keys(invalidList)[0]]
          this.$message({
            type: 'warning',
            message: invalid[0].message,
            duration: 5000
          })
        }
      })
    },

    submitCheck(albumObj, trackList) {
      const { userCompany } = this
      // 1 合作公司，3 优选内容 B，5 优选内容 C
      if (userCompany.type === 1 || userCompany.type === 3 || userCompany.type === 5) {
        const hasOnlyTrack = trackList.find(trackObj => trackObj.trackCopyright.isOnly === 1)

        // 存在总代理歌曲, 专辑必须上传授权文件
        if (hasOnlyTrack && albumObj.albumLicenseList.length === 0) {
          this.$message({
            type: 'error',
            message: '请上传授权文件'
          })
          return false
        }
      }

      return true
    },

    /**
     * 合同信息对象内的字段转换为后端需要的格式
     */
    cpToBackend(trackCopyright) {
      for (const toListField of toListFields) { // 需要转换的字段
        trackCopyright[toListField] = trackCopyright[toListField].join(',')
      }

      // 时间格式化
      trackCopyright.copyrightFrom = getDatetimeOrNull(trackCopyright.date[0])
      trackCopyright.copyrightTo = getDatetimeOrNull(trackCopyright.date[1], '23:59:59')

      return trackCopyright
    },

    /**
     * 排序, 统一字段
     * @param {Array} singerList - 专辑艺人对象数组
     * @param {Boolean} removeId - 是否移除 ID
     */
    _transformSinger(singerList, removeId = false) {
      const newSingerList = []
      for (let i = 0; i < singerList.length; i++) {
        const temp = cloneDeep(singerList[i])
        temp.orderIndex = i
        temp.albumList = undefined
        if (removeId) {
          temp.id = undefined
        }
        newSingerList.push(temp)
      }
      return newSingerList
    },

    async saveAlbum(data) {
      this.submitting = true
      try {
        const resp = await albumService.save(data, this.__reponse_time__)
        this.$autoCloseMsg(3000, {
          type: 'success',
          message: `${data.albumId ? '您的修改已成功提交，如涉及敏感字段修改还需审核！' : '创建专辑成功。'}3秒后转跳回列表页。`
        })
        ls.setItem('albumDraft', '') // 保存成功, 清空离线缓存

        setTimeout(_ => {
          this.$router.push({
            name: 'albumList',
            query: {
              id: resp.albumId,
              type: 'albumIdList'
            }
          })
        }, 3000)
      } catch (error) {
        this.$alert(`提交异常（${error.message}）`, '提示', { type: 'error', error })
      }
      this.submitting = false
    },

    /**
     * 申请修改专辑字段
     */
    handleApply() {
      if (this.lockBase === false) {
        return this.$message({
          type: 'info',
          message: '已经解锁'
        })
      }
      this.$alert('指定(带锁图标)的字段修改将会生成字段修改申请单，需要审批通过才能生效，请谨慎操作！', '提示', {
        type: 'warning'
      }).then(_ => {
        this.lockBase = false
      }).catch(_ => {})
    },
  }
}
</script>

<style lang="scss">
#album-edit {
  .form-field {
    width: 400px;
  }
  .avatar {
    display: inline-block;
    width: 400px;
    height: 120px;
    background-color: #fafafa;
    vertical-align: middle;
    border-radius: 4px;
    overflow: hidden;

    .pic {
      position: relative;
      float: left;
      width: 120px;
      height: 120px;
      background: #f0f0f0 url("~@/assets/images/album.png") 50% no-repeat;
      background-size: 80px 80px;
    }
    .pic-img {
      width: 120px;
      height: 120px;
      border: none;
    }

    .content {
      padding: 24px;
      float: left;
    }

    .line {
      line-height: 20px;
      color: rgba(0,0,0,.45);
      font-size: 12px;
    }
  }
  .upload-avatar {
    display: inline-block;
    vertical-align: middle;
  }

  .apply-icon {
    float: right;
    font-size: 14px;
    cursor: pointer;
    color: red;
  }
}

</style>
